export default __webpack_public_path__ + "static/media/faq.5c7a8f1b.png";